export class SituacoesVulnerabilidade {
	id: number;
	descricao: string;
	usuarioAlteracao: number;
	sigiloso: boolean;
}